module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "system-builder__select-communication--container"
  }, [_c('div', {
    staticClass: "system-builder__select-communication--item"
  }, [_c('img', {
    attrs: {
      "src": _vm.sharedState.customFields.two_way_image.url,
      "alt": _vm.sharedState.customFields.two_way_image.alt
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.sharedState.customFields.two_way_title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.customFields.two_way_description)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button__solid--blue",
    on: {
      "click": function($event) {
        _vm.setSelectedCommunication('2-way')
      }
    }
  }, [_vm._v("Select")])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__select-communication--item"
  }, [_c('img', {
    attrs: {
      "src": _vm.sharedState.customFields.one_way_image.url,
      "alt": _vm.sharedState.customFields.one_way_image.alt
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.sharedState.customFields.one_way_title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.customFields.one_way_description)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button__solid--blue",
    on: {
      "click": function($event) {
        _vm.setSelectedCommunication('1-way')
      }
    }
  }, [_vm._v("Select")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75c07cd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/SelectCommunicationType.vue
// module id = 426
// module chunks = 1